import {NgModule} from "@angular/core";
import {AvstemningListevisningKomponentAvhengigheter} from "./komponenter/avstemning-listevisning/avstemning-listevisning";
import {RedigerAvstemningDialogKomponentAvhengigheter} from "web-ng2/moduler/avstemning/modale/rediger-avstemning-dialog/rediger-avstemning-dialog";
import {AvstemningRedigerStemmeberettigedeKomponentAvhengigheter} from "web-ng2/moduler/avstemning/komponenter/avstemning-rediger-stemmeberettigede/avstemning-rediger-stemmeberettigede";
import {AvstemningerListeKomponentAvhengigheter} from "web-ng2/moduler/avstemning/komponenter/avstemninger-liste/avstemninger-liste";
import {AvstemningStemmeberettigedeKomponentAvhengigheter} from "web-ng2/moduler/avstemning/komponenter/avstemning-stemmeberettigede/avstemning-stemmeberettigede";

@NgModule({
    providers: [
        AvstemningListevisningKomponentAvhengigheter,
        RedigerAvstemningDialogKomponentAvhengigheter,
        AvstemningRedigerStemmeberettigedeKomponentAvhengigheter,
        AvstemningerListeKomponentAvhengigheter,
        AvstemningStemmeberettigedeKomponentAvhengigheter
    ]
})
export class AvstemningModul {

}
